import { render, staticRenderFns } from "./packages.compatibility.view.vue?vue&type=template&id=629a4ae5&"
import script from "./packages.compatibility.view.vue?vue&type=script&lang=ts&"
export * from "./packages.compatibility.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports